/**
 * @generated SignedSource<<fa57457bd3ecb4df820ea6ce99677144>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSocialShareEmail_user$data = {
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_user">;
  readonly " $fragmentType": "PdpSharedSocialShareEmail_user";
};
export type PdpSharedSocialShareEmail_user$key = {
  readonly " $data"?: PdpSharedSocialShareEmail_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSocialShareEmail_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSocialShareEmail_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSendToFriendModalLazy_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "aec5e8096d0e97c9f9dd0f3a604ed3a4";

export default node;
